import React from 'react';
import ToolLayout from '../../components/ToolLayout';
import HeicToJpg from '../../components/HeicToJpg';

const HeicToJpgPage: React.FC = () => (
  <ToolLayout
    title="HEIC to JPG Converter Free Online | AllTools"
    description="Convert HEIC and HEIF images to JPG format. Convert iPhone photos to JPG. Free online converter."
    canonicalPath="/heic-to-jpg"
  >
    <HeicToJpg />
  </ToolLayout>
);

export default HeicToJpgPage;
